import { enUS } from './en-US';
import { ptBR } from './pt-BR';

/**
 * Locales suportados.
 *
 * OBS (OAK-391): o espanhol ('es-ES') e um locale valido para fins de selecao
 * de idioma, mas a UI do portal ainda nao foi traduzida para espanhol. Por isso
 * ele reaproveita as strings em ingles (enUS) como fallback de UI. O efeito
 * pratico desejado e que, ao escolher espanhol, o formulario Ploomes
 * (DeviceRequestView) carregue em ES enquanto a UI permanece em EN.
 */
const locales: Record<string, { translation: any }> = {
  'en-US': { translation: enUS },
  'pt-BR': { translation: ptBR },
  'es-ES': { translation: enUS }
};

export default locales;
